/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface HospitalNoticeSimple {
  /** 병원 공지사항 고유 ID */
  _id?: string;
  /** 해당 공지사항이 작성된 순으로 1부터 시작되는 수 */
  index?: number;
  /** 해당 공지사항의 타이틀 문자열 */
  title?: string;
  /** 출력을 위한 조회 수 카운트 */
  viewCount?: number;
  /** 삭제 여부 플래그 */
  isRemoved?: boolean;
  /** 해당 공지사항이 게시되는 병원의 id */
  hospitalID?: string;
  /** 최초 작성일시 */
  createdAt?: string;
  /** 마지막 수정일시 */
  updatedAt?: string;
}

export interface HospitalNotice {
  /** 병원 공지사항 고유 ID */
  _id?: string;
  /** 해당 공지사항이 작성된 순으로 1부터 시작되는 수 */
  index?: number;
  /** 해당 공지사항의 타이틀 문자열 */
  title?: string;
  /** 해당 공지사항의 html tag 문자열 */
  content?: string;
  /** 출력을 위한 조회 수 카운트 */
  viewCount?: number;
  /** 삭제 여부 플래그 */
  isRemoved?: boolean;
  /** 해당 공지사항이 게시되는 병원의 id */
  hospitalID?: string;
  /** 최초 작성자의 UserID */
  writerID?: string;
  /** 마지막 수정자의 UserID */
  modifierID?: string;
  /** 최초 작성일시 */
  createdAt?: string;
  /** 마지막 수정일시 */
  updatedAt?: string;
}

export interface ServiceNotice {
  /** 서비스 알림 _id */
  _id: string;
  /** 메인 카테고리 */
  category: string;
  /** 서브카테고리 */
  subCategory: string;
  /** 제목 */
  title: string;
  /** 내용 */
  body: string;
  /** 추가 내용 */
  subbody?: string;
  /** 추가 콘텐츠가 있는 경우 내용과 구분하여 사용 */
  content?: string;
  /** 변경내역의 경우 변경 전 */
  beforeContent?: string;
  /** 변경내역인 경우 변경 후 */
  afterContent?: string;
  /** 유저의 읽음 여부 */
  isRead: boolean;
  /** 승인 관련 알림 발생 시  승인 여부 */
  isResponded?: boolean;
  /** 서비스 알림을 받는 대상자 */
  userID: string;
  /** 서비스 알림의 발송 대상병원 */
  hospitalID: string;
  /** 해당 알림에 필요한 추가 데이터. 서브 카테고리별로 정의 */
  data: Record<string, any>;
  /** 생성일 */
  createdAt: string;
}

export interface ApiNoticeHospitalElFindSimpleParams {
  /** (required) 병원 ID */
  hospitalID: string;
  /** 검색어 (제목) */
  keyword?: string;
  /** 삭제 여부 플래그 */
  isRemoved?: boolean;
  /** skip option */
  skip?: number;
  /** limit option */
  limit?: number;
  /** key option */
  key?: string;
  /** way option */
  way?: number;
}

export type ApiNoticeHospitalElFindSimpleData = ApiResponse & {
  data: HospitalNoticeSimple[];
};

export interface ApiNoticeHospitalElFindDetailParams {
  /** (required) 병원 공지사항 ID */
  _id: string;
}

export type ApiNoticeHospitalElFindDetailData = ApiResponse & {
  data: HospitalNotice;
};

export interface ApiNoticeHospitalElCountParams {
  /** (required) 병원 ID */
  hospitalID: string;
  /** 검색어 (공지사항 제목) */
  keyword?: string;
  /** 삭제 여부 플래그 */
  isRemoved?: boolean;
}

export type ApiNoticeHospitalElCountData = ApiResponse & {
  data: number;
};

export type ApiNoticeHospitalElCreateData = ApiResponse & {
  data: HospitalNotice;
};

export type ApiNoticeHospitalElUpdateData = ApiResponse & {
  data: HospitalNotice;
};

export type ApiNoticeHospitalElRemoveData = ApiResponse & {
  data: HospitalNotice;
};

export interface ApiNoticeServicenoticeElFindParams {
  /** 수신 대상 유저의 ID */
  userID: string;
  /** 발송된 병원의 ID */
  hospitalID: string;
  /** 서비스 알림 카테고리 */
  category?: string;
  /** 탭 필터 (system - 환자관리와 앱스토어, reservation - 예약관리). category와 상호 배타적. */
  tab?: "System" | "Reservation";
  /** 읽음 여부 */
  isRead?: boolean;
  /**
   * 서비스 알림 목록 조회 시작 일시
   * @default "2024-08-01"
   */
  startedAt?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
}

export type ApiNoticeServicenoticeElFindData = ApiResponse & {
  data: ServiceNotice[];
};

export interface ApiNoticeServicenoticeElCountParams {
  /** 수신 대상 유저의 ID */
  userID: string;
  /** 발송된 병원의 ID */
  hospitalID: string;
  /** 서비스 알림 카테고리 */
  category?: string;
  /** 탭 필터 (system - 환자관리와 앱스토어, reservation - 예약관리). category와 상호 배타적. */
  tab?: "System" | "Reservation";
  /** 읽음 여부 */
  isRead?: boolean;
  /**
   * 서비스 알림 목록 조회 시작 일시
   * @default "2024-08-01"
   */
  startedAt?: string;
}

export type ApiNoticeServicenoticeElCountData = ApiResponse & {
  data: number;
};

export type ApiNoticeServicenoticeElUpdateReadData = ApiResponse & {
  data: ServiceNotice;
};

export type ApiNoticeServicenoticeElUpdateReadAllData = any;

export interface ApiNoticeServicenoticeHmFindParams {
  /** 수신 대상 유저의 ID */
  userID: string;
  /** 발송된 병원의 ID */
  hospitalID: string;
  /** 서비스 알림 카테고리 */
  category?: string;
  /** 탭 필터 (system - 환자관리와 앱스토어, reservation - 예약관리). category와 상호 배타적. */
  tab?: "System" | "Reservation";
  /** 읽음 여부 */
  isRead?: boolean;
  /**
   * 서비스 알림 목록 조회 시작 일시
   * @default "2024-08-01"
   */
  startedAt?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
}

export type ApiNoticeServicenoticeHmFindData = ApiResponse & {
  data: ServiceNotice[];
};

export interface ApiNoticeServicenoticeHmCountParams {
  /** 수신 대상 유저의 ID */
  userID: string;
  /** 발송된 병원의 ID */
  hospitalID: string;
  /** 서비스 알림 카테고리 */
  category?: string;
  /** 탭 필터 (system - 환자관리와 앱스토어, reservation - 예약관리). category와 상호 배타적. */
  tab?: "System" | "Reservation";
  /** 읽음 여부 */
  isRead?: boolean;
  /**
   * 서비스 알림 목록 조회 시작 일시
   * @default "2024-08-01"
   */
  startedAt?: string;
}

export type ApiNoticeServicenoticeHmCountData = ApiResponse & {
  data: number;
};

export type ApiNoticeServicenoticeHmUpdateReadData = ApiResponse & {
  data: ServiceNotice;
};

export type ApiNoticeServicenoticeHmUpdateReadAllData = any;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description _id, title, hospitalID, index, isRemoved 출력
     *
     * @tags V3-HospitalNotice
     * @name ApiNoticeHospitalElFindSimple
     * @summary 병원별 공지사항 목록 간편 조회
     * @request GET:/v3/api/notice/hospital/el/find/simple
     * @secure
     * @response `200` `ApiNoticeHospitalElFindSimpleData` \[\{HospitalNotice\}\] 선택한 HospitalID 대한 HospitalNotice 컬렉션 객체 배열
     */
    apiNoticeHospitalElFindSimple: (query: ApiNoticeHospitalElFindSimpleParams, params: RequestParams = {}) =>
      this.request<ApiNoticeHospitalElFindSimpleData, any>({
        path: `/v3/api/notice/hospital/el/find/simple`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalNotice
     * @name ApiNoticeHospitalElFindDetail
     * @summary 병원별 공지사항 상세 조회
     * @request GET:/v3/api/notice/hospital/el/find/detail
     * @secure
     * @response `200` `ApiNoticeHospitalElFindDetailData` \{HospitalNotice\} HospitalNotice 컬렉션 객체
     */
    apiNoticeHospitalElFindDetail: (query: ApiNoticeHospitalElFindDetailParams, params: RequestParams = {}) =>
      this.request<ApiNoticeHospitalElFindDetailData, any>({
        path: `/v3/api/notice/hospital/el/find/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalNotice
     * @name ApiNoticeHospitalElCount
     * @summary 병원별 공지사항 목록 수 조회
     * @request GET:/v3/api/notice/hospital/el/count
     * @secure
     * @response `200` `ApiNoticeHospitalElCountData` 선택한 HospitalID 대한 HospitalNotice 수
     */
    apiNoticeHospitalElCount: (query: ApiNoticeHospitalElCountParams, params: RequestParams = {}) =>
      this.request<ApiNoticeHospitalElCountData, any>({
        path: `/v3/api/notice/hospital/el/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 그룹에 푸시 발송 시, [userTagIDs, doctorID, treatmentCategories, isFirstVisit] 를 배열로 전달. \ isFirstVisit 은 수신할 경우 항상 length 2의 boolean 배열. [초진여부, 재진여부] 형태
     *
     * @tags V3-HospitalNotice
     * @name ApiNoticeHospitalElCreate
     * @summary 병원별 공지사항 생성
     * @request POST:/v3/api/notice/hospital/el/create
     * @secure
     * @response `200` `ApiNoticeHospitalElCreateData` \{HospitalNotice\} 생성된 병원 공지사항 객체
     */
    apiNoticeHospitalElCreate: (
      data: {
        /** (required) 병원 ID */
        hospitalID: string;
        /** (required) 공지사항 제목 */
        title: string;
        /** (required) 공지사항 내용 */
        content: string;
        /** (required) 푸시 발송 여부 */
        isSendMessage: boolean;
        /** (required) 병원 내 고객에게 전체 발송 여부. false 시 필터 필요 */
        isSendToHospital: boolean;
        treatmentCategories?: string[];
        isFirstVisit?: boolean[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeHospitalElCreateData, any>({
        path: `/v3/api/notice/hospital/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalNotice
     * @name ApiNoticeHospitalElUpdate
     * @summary 병원별 공지사항 업데이트
     * @request POST:/v3/api/notice/hospital/el/update
     * @secure
     * @response `200` `ApiNoticeHospitalElUpdateData` \{HospitalNotice\} 업데이트된 HospitalNotice 객체
     */
    apiNoticeHospitalElUpdate: (
      data: {
        /** (required) 수정할 공지사항 ObjectId */
        _id: string;
        /** (required) 병원 ID */
        hospitalID: string;
        /** (required) 공지사항 제목 */
        title: string;
        /** (required) 공지사항 내용 */
        content: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeHospitalElUpdateData, any>({
        path: `/v3/api/notice/hospital/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HospitalNotice
     * @name ApiNoticeHospitalElRemove
     * @summary 병원별 공지사항 삭제
     * @request POST:/v3/api/notice/hospital/el/remove
     * @secure
     * @response `200` `ApiNoticeHospitalElRemoveData` \{HospitalNotice\} 삭제된 HospitalNotice 객체
     */
    apiNoticeHospitalElRemove: (
      data: {
        /** (required) 삭제할 공지사항 ObjectId */
        _id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeHospitalElRemoveData, any>({
        path: `/v3/api/notice/hospital/el/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ServiceNotice
     * @name ApiNoticeServicenoticeElFind
     * @summary 서비스 알림 목록 조회
     * @request GET:/v3/api/notice/servicenotice/el/find
     * @secure
     * @response `200` `ApiNoticeServicenoticeElFindData` \[\{ServiceNotice\}\] 서비스 알림 객체 배열
     */
    apiNoticeServicenoticeElFind: (query: ApiNoticeServicenoticeElFindParams, params: RequestParams = {}) =>
      this.request<ApiNoticeServicenoticeElFindData, any>({
        path: `/v3/api/notice/servicenotice/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ServiceNotice
     * @name ApiNoticeServicenoticeElCount
     * @summary 서비스 알림 수 조회
     * @request GET:/v3/api/notice/servicenotice/el/count
     * @secure
     * @response `200` `ApiNoticeServicenoticeElCountData` ServiceNotice 서비스 알림 수
     */
    apiNoticeServicenoticeElCount: (query: ApiNoticeServicenoticeElCountParams, params: RequestParams = {}) =>
      this.request<ApiNoticeServicenoticeElCountData, any>({
        path: `/v3/api/notice/servicenotice/el/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ServiceNotice
     * @name ApiNoticeServicenoticeElUpdateRead
     * @summary 서비스 알림 읽음처리
     * @request POST:/v3/api/notice/servicenotice/el/update/read
     * @secure
     * @response `200` `ApiNoticeServicenoticeElUpdateReadData` \{ServiceNotice\} 읽음 처리 된 서비스 알림 객체
     */
    apiNoticeServicenoticeElUpdateRead: (
      data: {
        /** 서비스 알림 ID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeServicenoticeElUpdateReadData, any>({
        path: `/v3/api/notice/servicenotice/el/update/read`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description - 유저 기준 서비스 알림 모두읽음 처리 - userID 전달, 일부 카테고리만 읽음 처리 시 category 추가 전달
     *
     * @tags V3-ServiceNotice
     * @name ApiNoticeServicenoticeElUpdateReadAll
     * @summary 유저 기준 서비스 알림 모두읽음 처리
     * @request POST:/v3/api/notice/servicenotice/el/update/read/all
     * @secure
     * @response `200` `ApiNoticeServicenoticeElUpdateReadAllData` 서비스 알림 모두 읽음 처리 여부
     */
    apiNoticeServicenoticeElUpdateReadAll: (
      data: {
        /** 서비스 알림 모두읽음 처리할 userID */
        userID: string;
        /** 서비스 알림 카테고리. 비어있을 경우 모든 카테고리 */
        category?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeServicenoticeElUpdateReadAllData, any>({
        path: `/v3/api/notice/servicenotice/el/update/read/all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ServiceNotice
     * @name ApiNoticeServicenoticeHmFind
     * @summary 병원 상담 모바일 앱 - 서비스 알림 목록 조회
     * @request GET:/v3/api/notice/servicenotice/hm/find
     * @secure
     * @response `200` `ApiNoticeServicenoticeHmFindData` \[\{ServiceNotice\}\] 서비스 알림 객체 배열
     */
    apiNoticeServicenoticeHmFind: (query: ApiNoticeServicenoticeHmFindParams, params: RequestParams = {}) =>
      this.request<ApiNoticeServicenoticeHmFindData, any>({
        path: `/v3/api/notice/servicenotice/hm/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ServiceNotice
     * @name ApiNoticeServicenoticeHmCount
     * @summary 병원 상담 모바일 앱 - 서비스 알림 수 조회
     * @request GET:/v3/api/notice/servicenotice/hm/count
     * @secure
     * @response `200` `ApiNoticeServicenoticeHmCountData` ServiceNotice 서비스 알림 수
     */
    apiNoticeServicenoticeHmCount: (query: ApiNoticeServicenoticeHmCountParams, params: RequestParams = {}) =>
      this.request<ApiNoticeServicenoticeHmCountData, any>({
        path: `/v3/api/notice/servicenotice/hm/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ServiceNotice
     * @name ApiNoticeServicenoticeHmUpdateRead
     * @summary 병원 상담 모바일 앱 - 서비스 알림 읽음처리
     * @request POST:/v3/api/notice/servicenotice/hm/update/read
     * @secure
     * @response `200` `ApiNoticeServicenoticeHmUpdateReadData` \{ServiceNotice\} 읽음 처리 된 서비스 알림 객체
     */
    apiNoticeServicenoticeHmUpdateRead: (
      data: {
        /** 서비스 알림 ID */
        _id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeServicenoticeHmUpdateReadData, any>({
        path: `/v3/api/notice/servicenotice/hm/update/read`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description - 유저 기준 서비스 알림 모두읽음 처리 - userID 전달, 일부 카테고리만 읽음 처리 시 category 추가 전달
     *
     * @tags V3-ServiceNotice
     * @name ApiNoticeServicenoticeHmUpdateReadAll
     * @summary 병원 상담 모바일 앱 - 유저 기준 서비스 알림 모두읽음 처리
     * @request POST:/v3/api/notice/servicenotice/hm/update/read/all
     * @secure
     * @response `200` `ApiNoticeServicenoticeHmUpdateReadAllData` 서비스 알림 모두 읽음 처리 여부
     */
    apiNoticeServicenoticeHmUpdateReadAll: (
      data: {
        /** 서비스 알림 모두읽음 처리할 userID */
        userID: string;
        /** 서비스 알림 카테고리. 비어있을 경우 모든 카테고리 */
        category?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiNoticeServicenoticeHmUpdateReadAllData, any>({
        path: `/v3/api/notice/servicenotice/hm/update/read/all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
